import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { OfferModalContainer } from '@/features/opportunities/offers/components/OfferModal/OfferModalContainer'
import { WorkspaceInvitationModalContainer } from '@/features/opportunities/invitations/components/WorkspaceInvitationModal/WorkspaceInvitationModalContainer'
import { ConsultationModalContainer } from '@/features/opportunities/ConsultationModal/ConsultationModalContainer'

/**
 * Inner component which requests the actual loading of the module.
 */
export default observer(function Inner() {
  const { opportunities } = useFeatures((r) => ({
    opportunities: r.opportunities.internal(),
  }))
  return (
    <>
      {opportunities.opportunityOffersVm.offerModalViewModels.map((vm) => (
        <OfferModalContainer vm={vm} key={vm.id} />
      ))}
      {opportunities.workspaceOpportunityInvitationsVm.invitationModalVms.map(
        (vm) => (
          <WorkspaceInvitationModalContainer vm={vm} key={vm.id} />
        ),
      )}
      <ConsultationModalContainer vm={opportunities.consultationModalVm} />
    </>
  )
})
